import { ERouteHttpVerb } from "@devowl-wp/api";
const locationRestPluginGet = {
    path: "/plugin",
    method: ERouteHttpVerb.GET
};
export { locationRestPluginGet };
